import { isAuthorized } from 'utils/Auth'
import { createReducer } from '../../utils'

export const TAG_REQUEST = 'sherrinford/tag/list/TAG_REQUEST'
export const TAG_SUCCESS = 'sherrinford/tag/list/TAG_SUCCESS'
export const TAG_ERROR = 'sherrinford/tag/list/TAG_ERROR'

export const TAG_USER_SUBMISSION_REQUEST = 'sherrinford/tag/list/TAG_USER_SUBMISSION_REQUEST'
export const TAG_USER_SUBMISSION_SUCCESS = 'sherrinford/tag/list/TAG_USER_SUBMISSION_SUCCESS'
export const TAG_USER_SUBMISSION_FAILED = 'sherrinford/tag/list/TAG_USER_SUBMISSION_FAILED'

export const IS_LOADING = 'sherrinford/tag/list/IS_LOADING'
export const DATA = 'sherrinford/tag/list/DATA'

export const SET_MODAL_TAG_USER_SUBMISSION = 'sherrinford/tag/list/SET_MODAL_TAG_USER_SUBMISSION'

export const SET_ACTION = 'sherrinford/tag/list/SET_ACTION'

export const SET_ID_TAG_SELECTED = 'sherrinford/tag/list/SET_SET_ID_TAG_SELECTED'

export const SET_FILTER_NAME = 'sherrinford/tag/list/SET_FILTER_NAME'

export const SET_FILTER_NAME_USER_SUBMISSION = 'sherrinford/tag/list/SET_FILTER_NAME_USER_SUBMISSION'

export const RESET_FILTER = 'sherrinford/tag/list/RESET_FILTER'

export const SET_TAGS_USER_SUBMISSION_SELECTED = 'sherrinford/tag/list/SET_TAGS_USER_SUBMISSION_SELECTED'

export const SET_IS_MODAL_MERGE_OPEN = 'sherrinford/tag/list/SET_IS_MODAL_MERGE_OPEN'

export const SET_INPUT_MERGE_NAME = 'sherrinford/tag/list/SET_INPUT_MERGE_NAME'

export const MERGE_TAG_REQUEST = 'sherrinford/tag/list/MERGE_TAG_REQUEST'
export const MERGE_TAG_SUCCESS = 'sherrinford/tag/list/MERGE_TAG_SUCCESS'
export const MERGE_TAG_ERROR = 'sherrinford/tag/list/MERGE_TAG_ERROR'

export const SET_TYPE_MERGE = 'sherrinford/tag/list/SET_TYPE_MERGE'

export const GET_TAG_SELECTION_REQUEST = 'sherrinford/tag/list/GET_TAG_SELECTION_REQUEST'
export const GET_TAG_SELECTION_SUCCESS = 'sherrinford/tag/list/GET_TAG_SELECTION_SUCCESS'
export const GET_TAG_SELECTION_ERROR = 'sherrinford/tag/list/GET_TAG_SELECTION_ERROR'

export const SET_EXISTING_TAG_SELECTED = 'sherrinford/list/SET_EXISTING_TAG_SELECTED'

export const SET_IS_DIALOG_ALERT_OPEN = 'sherrinford/list/SET_IS_DIALOG_ALERT_OPEN'

export const SET_DIALOG_ALERT_MESSAGE = 'sherrinford/list/SET_DIALOG_ALERT_MESSAGE'

export const SET_FILTER_SORT_LIVE_DATA = 'sherrinford/list/SET_FILTER_SORT_LIVE_DATA'

export const SET_FILTER_SORT_USER_SUBMISSION = 'sherrinford/list/SET_FILTER_SORT_USER_SUBMISSION'

export const SET_TAG_LIVE_DATA_SELECTED = 'sherrinford/list/SET_TAG_LIVE_DATA_SELECTED'

export const SET_DATA_TYPE_ACTIVE = 'sherrinford/list/SET_DATA_TYPE_ACTIVE'

const initialState = {
  data: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
  },
  tagUserSubmission: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
  },
  tagUserSubmissionSelected: [],
  isLoading: false,
  isError: false,
  errorMessage: '',
  isModalTagSubmissionOpen: false,
  action: '',
  idTagSelected: '',
  filterName: '',
  filterNameUserSubmission: '',
  isModalMergeOpen: false,
  inputMergeName: '',
  typeMerge: 'newData',
  tagSelection: {
    count: 0,
    currentPage: 1,
    totalPages: 0,
    rows: [],
  },
  existingTagSelected: '',
  isDialogAlertOpen: false,
  dialogAlertMessage: '',
  liveDataFilter: {
    active: 'name',
    sort: '',
  },
  userSubmissionFilter: {
    active: 'name',
    sort: '',
  },
  tagLiveDataSelected: [],
  dataTypeActive: '',
}

export default createReducer(initialState, {
  [TAG_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [TAG_SUCCESS]: (state, data) => ({
    ...state,
    data,
    isLoading: false,
  }),
  [TAG_ERROR]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [TAG_USER_SUBMISSION_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),
  [TAG_USER_SUBMISSION_SUCCESS]: (state, data) => ({
    ...state,
    tagUserSubmission: data,
    isLoading: false,
  }),
  [TAG_USER_SUBMISSION_FAILED]: (state, data) => ({
    ...state,
    isError: true,
    errorMessage: data.message,
    isLoading: false,
  }),

  [IS_LOADING]: (state, data) => ({
    ...state,
    isLoading: data,
  }),

  [DATA]: (state, data) => ({
    ...state,
    data,
  }),

  [SET_MODAL_TAG_USER_SUBMISSION]: (state, data) => ({
    ...state,
    isModalTagSubmissionOpen: data,
  }),

  [SET_ACTION]: (state, data) => ({
    ...state,
    action: data,
  }),

  [SET_ID_TAG_SELECTED]: (state, data) => ({
    ...state,
    idTagSelected: data,
  }),

  [SET_FILTER_NAME]: (state, data) => ({
    ...state,
    filterName: data,
  }),

  [SET_FILTER_NAME_USER_SUBMISSION]: (state, data) => ({
    ...state,
    filterNameUserSubmission: data,
  }),

  [RESET_FILTER]: state => ({
    ...state,
    filterName: '',
    filterNameUserSubmission: '',
  }),

  [SET_TAGS_USER_SUBMISSION_SELECTED]: (state, data) => ({
    ...state,
    tagUserSubmissionSelected: data,
  }),

  [SET_IS_MODAL_MERGE_OPEN]: (state, data) => ({
    ...state,
    isModalMergeOpen: data,
  }),

  [SET_INPUT_MERGE_NAME]: (state, data) => ({
    ...state,
    inputMergeName: data,
  }),

  [SET_TYPE_MERGE]: (state, data) => ({
    ...state,
    typeMerge: data,
  }),

  [GET_TAG_SELECTION_REQUEST]: state => ({
    ...state,
    isLoading: true,
  }),

  [GET_TAG_SELECTION_SUCCESS]: (state, data) => ({
    ...state,
    isLoading: false,
    tagSelection: data,
  }),

  [GET_TAG_SELECTION_ERROR]: state => ({
    ...state,
    isLoading: false,
  }),

  [SET_EXISTING_TAG_SELECTED]: (state, data) => ({
    ...state,
    existingTagSelected: data,
  }),

  [SET_IS_DIALOG_ALERT_OPEN]: (state, data) => ({
    ...state,
    isDialogAlertOpen: data,
  }),

  [SET_DIALOG_ALERT_MESSAGE]: (state, data) => ({
    ...state,
    dialogAlertMessage: data,
  }),

  [SET_FILTER_SORT_LIVE_DATA]: (state, data) => ({
    ...state,
    liveDataFilter: data,
  }),

  [SET_FILTER_SORT_USER_SUBMISSION]: (state, data) => ({
    ...state,
    userSubmissionFilter: data,
  }),

  [SET_TAG_LIVE_DATA_SELECTED]: (state, data) => ({
    ...state,
    tagLiveDataSelected: data,
  }),

  [SET_DATA_TYPE_ACTIVE]: (state, data) => ({
    ...state,
    dataTypeActive: data,
  }),
})

export const getTags = (qs = {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      TAG_REQUEST,
      TAG_SUCCESS,
      TAG_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/tag',
      authorization: `${token}`,
      payloads: {
        ...qs,
        where: {
          ...qs.where,
          status: 2,
        },
      },
    },
  }
}

export const getTagsUserSubmission = (qs = {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      TAG_USER_SUBMISSION_REQUEST,
      TAG_USER_SUBMISSION_SUCCESS,
      TAG_USER_SUBMISSION_FAILED,
    ],
    shuttle: {
      method: 'GET',
      path: '/tag',
      authorization: `${token}`,
      payloads: {
        ...qs,
        where: {
          ...qs.where,
          status: 1,
        },
      },
    },
  }
}

export const mergeTags = (data, cb = () => { }) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      MERGE_TAG_REQUEST,
      MERGE_TAG_SUCCESS,
      MERGE_TAG_ERROR,
    ],
    shuttle: {
      method: 'POST',
      path: '/tag/merge',
      authorization: `${token}`,
      payloads: data,
    },
    nextAction: (res, err) => cb(res, err),
  }
}

export const getTagSelection = (qs = {}) => {
  const token = JSON.parse(isAuthorized())
  return {
    type: [
      GET_TAG_SELECTION_REQUEST,
      GET_TAG_SELECTION_SUCCESS,
      GET_TAG_SELECTION_ERROR,
    ],
    shuttle: {
      method: 'GET',
      path: '/tag',
      authorization: `${token}`,
      payloads: {
        ...qs,
        where: {
          ...qs.where,
          status: 2,
        },
      },
    },
  }
}

export const setData = data => ({
  type: [DATA],
  payload: data,
})

export const setLoadState = data => ({
  type: [IS_LOADING],
  payload: data,
})

export const setModalTagUserSubmission = data => ({
  type: [SET_MODAL_TAG_USER_SUBMISSION],
  payload: data,
})

export const setAction = data => ({
  type: [SET_ACTION],
  payload: data,
})

export const setIdTagSelected = data => ({
  type: [SET_ID_TAG_SELECTED],
  payload: data,
})

export const setFilterName = data => ({
  type: [SET_FILTER_NAME],
  payload: data,
})

export const setFilterNameUserSubmission = data => ({
  type: [SET_FILTER_NAME_USER_SUBMISSION],
  payload: data,
})

export const resetFilter = () => ({
  type: [RESET_FILTER],
})

export const setTagsUserSubmissionSelected = data => ({
  type: [SET_TAGS_USER_SUBMISSION_SELECTED],
  payload: data,
})

export const setIsModalMergeOpen = data => ({
  type: [SET_IS_MODAL_MERGE_OPEN],
  payload: data,
})

export const setInputMergeName = data => ({
  type: [SET_INPUT_MERGE_NAME],
  payload: data,
})

export const setTypeMerge = data => ({
  type: [SET_TYPE_MERGE],
  payload: data,
})

export const setExistingTagSelected = data => ({
  type: [SET_EXISTING_TAG_SELECTED],
  payload: data,
})

export const setIsDialogAlertOpen = data => ({
  type: [SET_IS_DIALOG_ALERT_OPEN],
  payload: data,
})

export const setDialogAlertMessage = data => ({
  type: [SET_DIALOG_ALERT_MESSAGE],
  payload: data,
})

export const setFilterSortLiveData = data => ({
  type: [SET_FILTER_SORT_LIVE_DATA],
  payload: data,
})

export const setFilterSortUserSubmission = data => ({
  type: [SET_FILTER_SORT_USER_SUBMISSION],
  payload: data,
})

export const setTagLiveDataSelected = data => ({
  type: [SET_TAG_LIVE_DATA_SELECTED],
  payload: data,
})

export const setDataTypeActive = data => ({
  type: [SET_DATA_TYPE_ACTIVE],
  payload: data,
})
